module.exports = __webpack_public_path__ + "static/media/no-data-img.b74b8fc7.png";